module.exports = __webpack_public_path__ + "public/Icons/plusIcon.svg?96d897e9";